import { Component, OnInit, forwardRef } from '@angular/core';
import { NavController, NavParams, Platform, ModalController, AlertController, IonicModule } from '@ionic/angular';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { AnimationController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { ImagePipe } from 'src/app/pipes/image/image';

@Component({
  selector: 'app-grupo-adm-imagem-add',
  templateUrl: './grupo-adm-imagem-add.page.html',
  styleUrls: ['./grupo-adm-imagem-add.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    ImagePipe,
  ],
})
export class GrupoAdmImagemAddPage implements OnInit {
  idGrupo: any;
  entidade: any = '';
  imageList: any = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public grupoProvider: GrupoProvider,
    public plt: Platform,
    public modalCtrl: ModalController,
    public animationCtrl: AnimationController,
    public translate: TranslateService,
    public alertCtrl: AlertController,
  ) {
    this.idGrupo = this.navParams.get('idGrupo');
    this.entidade = this.navParams.get('entidade');
    this.imageList = this.navParams.get('imageList');
  }

  ngOnInit() {
  }

  async removerFoto(idFoto: string) {
    let confirmAlert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant('Atenção'),
      message: this.translate.instant('Deseja realmente essa imagem?'),
      buttons: [
        {
          text: this.translate.instant('Não'),
          role: 'cancel',
        },
        {
          text: this.translate.instant('Sim'),
          handler: () => {
            this.grupoProvider.removerImagem(idFoto).subscribe(() => {
              this.grupoProvider.getFotoReuniao(this.entidade, this.idGrupo).subscribe((data) => {
                this.imageList = data;
                this.modalCtrl.dismiss(this.imageList);
              });
            });
          },
        },
      ],
    });

    confirmAlert.present();
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
